
import React from 'react';
import { Trash2, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

interface ChatHeaderProps {
  isExpanded: boolean;
  onClearChat?: () => void;
}

const ChatHeader = ({ isExpanded, onClearChat }: ChatHeaderProps) => {
  return (
    <div className="p-4 border-b border-goldcore/10 bg-knightblack/30 flex justify-between items-center">
      <div className="flex items-center">
        <Link 
          to="/" 
          className="text-goldcore/70 hover:text-goldcore p-2 rounded-full hover:bg-deepshadow/30 transition-colors mr-2"
          title="Back to home"
        >
          <ArrowLeft size={20} />
        </Link>
        <img 
          src="/lovable-uploads/0aa296c2-39b8-4316-97b8-2a5754cf1180.png" 
          alt="GoldCrusade logo" 
          className="h-8 w-8 mr-3" 
        />
        <div>
          <h2 className="text-xl font-semibold text-softwhite">KnightAI</h2>
          <p className="text-sm text-goldcore">Business Qualification Assistant</p>
        </div>
      </div>
      
      {onClearChat && (
        <button 
          onClick={onClearChat}
          className="text-goldcore/70 hover:text-goldcore p-2 rounded-full hover:bg-deepshadow/30 transition-colors"
          title="Clear conversation"
        >
          <Trash2 size={20} />
        </button>
      )}
    </div>
  );
};

export default ChatHeader;
